import { type Context, type SetStateAction } from 'react';
import { createContext, useContext } from 'react';
import type * as React from 'react';

import type { MenuListProps } from '../../../menu-list/MenuList';

export const DropdownContext = createContext<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  filteredItems: any[]; // Default to any[] for flexibility, T will be used when necessary
  isMobile: boolean;
  focusIndex?: number;
  MenuListProps?: MenuListProps;
  setFocusIndex?: React.Dispatch<SetStateAction<number | undefined>>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onMenuItemClick?: (item: any) => void;
}>({
  filteredItems: [],
  focusIndex: -1,
  isMobile: false,
  MenuListProps: {},
  onMenuItemClick: () => undefined,
  setFocusIndex: () => undefined,
});

export const useDropdownContent = <T>() => {
  const context = useContext(
    DropdownContext as Context<{
      filteredItems: T[];
      isMobile: boolean;
      focusIndex?: number;
      MenuListProps?: MenuListProps;
      setFocusIndex?: React.Dispatch<SetStateAction<number | undefined>>;
      onMenuItemClick?: (item: T) => void;
    }>
  );

  if (!context) {
    throw new Error('useDropdown must be used within a DropdownProvider');
  }

  return context;
};
